import { DOCUMENT } from "@angular/common";
import {
  Component,
  Inject,
  ElementRef,
  OnInit,
  Renderer2,
  AfterViewInit,
  TemplateRef,
} from "@angular/core";
import { Router } from "@angular/router";
import { ConfigService } from "src/app/config/config.service";
import { AuthService } from "src/app/core/service/auth.service";
import { RightSidebarService } from "src/app/core/service/rightsidebar.service";
import { LanguageService } from "src/app/core/service/language.service";
import { UnsubscribeOnDestroyAdapter } from "src/app/shared/UnsubscribeOnDestroyAdapter";
import { User } from "src/app/core/models/user";
import { ModalForgotPasswordComponent } from "src/app/authentication/signin/modal-forgot-password/modal-forgot-password.component";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { ModalUpdatePasswordComponent } from "src/app/authentication/signin/modal-update-password/modal-update-password.component";
import { RestClientService } from "src/app/core/service/rest-client.service";
import { Subscription } from "rxjs";
const document: any = window.document;
import { interval } from "rxjs";
import * as moment from "moment";
import { UtilitiesService } from "src/app/core/service/utilities.service";
import { PriseDeDecisionWorkflowComponent } from "src/app/shared/components/prise-de-decision-workflow/prise-de-decision-workflow.component";
import {
  enumCodeCircuitValidation,
  enumOrigineOuvertureModalForNotification,
  enumTypeRetour,
} from "src/app/core/enumerator/enumerator";
import * as _ from "lodash";
import Swal from "sweetalert2";
import { WebSocketService } from "src/app/core/service/websocket.service";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent
  extends UnsubscribeOnDestroyAdapter
  implements OnInit, AfterViewInit
{
  public config: any = {};
  userImg: string;
  homePage: string;
  isNavbarCollapsed = true;
  flagvalue;
  modalRef?: BsModalRef;
  currentUser: User;
  countryName;
  langStoreValue: string;
  defaultFlag: string;
  isOpenSidebar: boolean;
  activeUniteFonctionnelle: any = {};
  currentTotalItems: any = 0;
  listeNotifications: any = [];
  selectedExercice: any = {};
  itemsExercice: any = [];
  listeActesExamens: any = [];
  busySave: Subscription;
  busyGet: Subscription;
  user: any = {};
  codeCirucit: any = {};
  acteSelected: any = {};
  isInterpretationRadioOrLabo: boolean;

  subscribeEcouteNotification?: Subscription;
  requestRefreshNotifications?: Subscription;
  itemToSave: any = {};
  isOpen: boolean;
  indiceTab: number = 0;
  loading: boolean;
  pollingInterval: any;

  private webSocketSubscription: Subscription;
  private webSocketSubscriptionRandomUsers: Subscription;
  private isWebSocketConnected = false;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    public elementRef: ElementRef,
    private rightSidebarService: RightSidebarService,
    private configService: ConfigService,
    private authService: AuthService,
    private router: Router,
    public languageService: LanguageService,
    private modalService: BsModalService,
    private restClient: RestClientService,
    private utilities: UtilitiesService,
    private websocketService: WebSocketService,
  ) {
    super();
    // debugger
    this.user = this.authService.currentUserValue;
    this.codeCirucit = enumCodeCircuitValidation;
    this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
    console.log("currentUser =====>", this.currentUser);

    setInterval(() => {
      this.getNotifications();
    }, 10000);
  }

  listLang = [
    { text: "English", flag: "assets/images/flags/us.svg", lang: "en" },
    { text: "Spanish", flag: "assets/images/flags/spain.svg", lang: "es" },
    { text: "German", flag: "assets/images/flags/germany.svg", lang: "de" },
  ];

  notifications: any[] = [
    {
      message: "Please check your mail",
      time: "14 mins ago",
      icon: "mail",
      color: "nfc-green",
      status: "msg-unread",
    },
    {
      message: "New Patient Added..",
      time: "22 mins ago",
      icon: "person_add",
      color: "nfc-blue",
      status: "msg-read",
    },
    {
      message: "Your leave is approved!! ",
      time: "3 hours ago",
      icon: "event_available",
      color: "nfc-orange",
      status: "msg-read",
    },
    {
      message: "Lets break for lunch...",
      time: "5 hours ago",
      icon: "lunch_dining",
      color: "nfc-blue",
      status: "msg-read",
    },
    {
      message: "Patient report generated",
      time: "14 mins ago",
      icon: "description",
      color: "nfc-green",
      status: "msg-read",
    },
    {
      message: "Please check your mail",
      time: "22 mins ago",
      icon: "mail",
      color: "nfc-red",
      status: "msg-read",
    },
    {
      message: "Salary credited...",
      time: "3 hours ago",
      icon: "paid",
      color: "nfc-purple",
      status: "msg-read",
    },
  ];

  ngOnInit() {
    this.getItemsSystemeGlobal();
    this.getItemsExercice();
    // this.refreshDataNotification();
    this.getNotifications();

    let uf = JSON.parse(
      localStorage.getItem("currentUser"),
    )?.uniteFonctionnelles;

    if (uf) {
      this.activeUniteFonctionnelle = uf.filter(
        (auf) =>
          auf.idUniteFonctionnelle ==
          JSON.parse(localStorage.getItem("currentUser")).uniteFoncActiveId,
      )[0];
    }
    this.config = this.configService.configData;
    // const userRole = this.authService.currentUserValue.role;
    this.userImg = localStorage.getItem("currentUser")
      ? (JSON.parse(localStorage.getItem("currentUser")).image_url ??
        "assets/images/custom/user-ano.jpeg")
      : "";

    this.langStoreValue = localStorage.getItem("lang");
    const val = this.listLang.filter((x) => x.lang === this.langStoreValue);
    this.countryName = val.map((element) => element.text);
    if (val.length === 0) {
      if (this.flagvalue === undefined) {
        this.defaultFlag = "assets/images/flags/us.svg";
      }
    } else {
      this.flagvalue = val.map((element) => element.flag);
    }

    this.subscribeEcouteNotification =
      this.utilities.currentStatutToRefreshNotification.subscribe(
        (currentData) => {
          if (
            currentData &&
            currentData ==
              enumOrigineOuvertureModalForNotification?.validation_screen
          ) {
            // Cela suppose qu'on a fait une validation depuis l'interface de validation sans passer par le bouton traiter de notification
            // this.getNotifications();
          }
        },
      );

    // this.connectToWebSocket();
    // this.getNotifications(); // Initial load
    // this.websocketService.connectRandomUserSocket()
    // this.websocketService.connectRandomUserSocketPeriodic()
    // this.websocketService.prestationActeConnect()
    // this.websocketService.beneficiairePrestationConnect(1324)

    // this.websocketService.beneficiairePrestationConnect(123);
    // this.websocketService.logBeneficiairePrestationStatus();

    // this.websocketService.beneficiairePrestationSend({ action: 'ping' });
    // this.websocketService.logBeneficiairePrestationStatus();
  }

  connectToWebSocket(): void {
    this.websocketService.connectUserNotifications();

    this.webSocketSubscription =
      this.websocketService.userNotifications$.subscribe((message) => {
        if (message.type === "connection_established") {
          this.isWebSocketConnected = true;
          console.log("WebSocket connected successfully");
        } else if (message.type === "refresh_needed") {
          console.log("Server says: refresh notifications");
          this.getNotifications(); // Refresh when server tells us to
        } else if (message.type === "new_notification") {
          console.log("New notification received:", message.data);
          this.handleNewNotification(message.data);
        } else if (message.type === "connection_error") {
          this.isWebSocketConnected = false;
          console.error("WebSocket connection error:", message.error);
          this.startFallbackPolling(); // Fallback to polling
        }
      });
  }

  private notificationSubscription: Subscription;
  handleNewNotification(notificationData: any): void {
    // Add new notification to the list
    this.listeNotifications.unshift(notificationData);
    this.currentTotalItems++;

    // Show alert
    const messageNotification = "🛎️ Nouvelle notification reçue !";
    this.utilities.showNotification(
      "snackbar-danger",
      messageNotification,
      "bottom",
      "right",
      true,
    );
  }

  handleNotificationUpdate(updateData: any): void {
    // Update existing notification
    const index = this.listeNotifications.findIndex(
      (n) => n.id === updateData.id,
    );
    if (index !== -1) {
      this.listeNotifications[index] = updateData;
    }
  }

  // Keep your existing getNotifications method for initial load
  getNotifications() {
    if (!this.user?.id) return;

    const request = {
      user: this.user.id,
      // order_by:'-created_at',
      data: {
        // has_validation:true
      },
      index: 0,
      size: 1000,
    };

    this.restClient.post("notification/getInProgress", request).subscribe(
      (res) => {
        if (res && res["items"]) {
          this.listeNotifications = res["items"];
          this.currentTotalItems = res["count"];
          console.info(
            "Initial notifications loaded:",
            this.listeNotifications,
          );
        } else {
          this.listeNotifications = [];
          this.currentTotalItems = 0;
        }
      },
      (err) => {
        console.error("Error loading notifications:", err);
      },
    );
  }

  // Fallback polling if WebSocket fails
  startFallbackPolling(): void {
    console.log("Starting fallback polling...");
    this.pollingInterval = setInterval(() => {
      this.getNotifications();
    }, 10000); // Every 30 seconds instead of frequent polling
  }

  ngOnDestroy(): void {
    // Clean up subscriptions
    if (this.webSocketSubscription) {
      this.webSocketSubscription.unsubscribe();
    }
    // if (this.pollingInterval) {
    //   clearInterval(this.pollingInterval);
    // }
    this.websocketService.disconnect();

    if (this.subscribeEcouteNotification) {
      this.subscribeEcouteNotification.unsubscribe();
    }
  }

  selectedChangeValue(event: any) {
    console.log("le event selectedChangeValue", event);

    if (!event) this.indiceTab = 0;

    this.indiceTab = event;
  }

  openModal(data: any, template: TemplateRef<any>) {
    let config = { backdrop: true, ignoreBackdropClick: true };

    if (data) {
      // Lorsque nous sommes en modification
      this.itemToSave = { ...data };
    }
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, config, { class: "modal-lg modal-width-90" }),
    );
  }

  onSelectExercice(selectedExercice) {
    let currentUserJson = JSON.parse(localStorage.getItem("currentUser"));

    if (currentUserJson && selectedExercice) {
      currentUserJson.exerciceActive = selectedExercice;
      localStorage.setItem(
        "currentUserGarant",
        JSON.stringify(currentUserJson),
      );

      //On le ramene à l'accueil
      // this.router.navigate(["/accueil"]);

      // setTimeout(() => {
      //   location.reload();
      // }, 1000);
    }
  }

  onReadNotification(item) {
    item.is_read = true;
    let request = {
      user: this.user.id,
      datas: [item],
    };

    this.restClient.post("notification/xupdate", request).subscribe(
      (res) => {
        // console.info(" res ", res);

        if (res && !res["status"]["hasError"]) {
          this.getNotifications();
        } else {
          this.listeNotifications = [];
          this.currentTotalItems = 0;
        }
      },
      (err) => {},
    );
  }

  confirmSaveItem(item) {
    console.info("item: ", item);

    console.info(" itemToSave ", this.itemToSave);
    console.info(" item ", item);

    if (!item.id && !item.code) item.code = this.generateUniqueString();
    if (!item.id && !item.codification)
      item.codification = this.generateUniqueString();

    if (!item.id && !item.libelle) item.libelle = this.generateUniqueString();
    // if (!item || !item.code) {
    //   this.utilities.showNotification(
    //     "snackbar-danger",
    //     "Veuillez renseigner code !",
    //     "bottom",
    //     "center"
    //   );
    //   return;
    // }
    // if (!item || !item.codification) {
    //   this.utilities.showNotification(
    //     "snackbar-danger",
    //     "Veuillez renseigner codification !",
    //     "bottom",
    //     "center"
    //   );
    //   return;
    // }

    // item.specialiteId = this.selectedSpecialite.id
    // if (!item || !item.libelle) {
    //   this.utilities.showNotification(
    //     "snackbar-danger",
    //     "Veuillez renseigner libellé !",
    //     "bottom",
    //     "center"
    //   );
    //   return;
    // }

    let objToSave = Object.assign({}, item);

    Swal.fire({
      title: "Traitement",
      text: "Traitement",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#0665aa",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui",
      cancelButtonText: "Non",
    }).then((result) => {
      if (result.value) {
        this.saveItem(objToSave);
      }
    });
  }
  confirmMarkAsRead(item) {
    console.info("item: ", item);

    console.info(" itemToSave ", this.itemToSave);
    console.info(" item ", item);

    let objToSave: any = {};
    objToSave.notification_id = item.id;
    if (!objToSave.id && !objToSave.code)
      objToSave.code = this.generateUniqueString();
    if (!objToSave.id && !objToSave.codification)
      objToSave.codification = this.generateUniqueString();

    if (!objToSave.id && !objToSave.libelle)
      objToSave.libelle = this.generateUniqueString();

    Swal.fire({
      title: "Marquer lu",
      text: "Marquer lu",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#0665aa",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui",
      cancelButtonText: "Non",
    }).then((result) => {
      if (result.value) {
        this.makItemAsRead(objToSave);
      }
    });
  }

  saveItem(item) {
    console.info("item to save", item);

    this.loading = true;

    let itemAEnregistrer = Object.assign({}, item);
    itemAEnregistrer.notification_id = this.itemToSave.id;
    itemAEnregistrer.break_circuit = !!itemAEnregistrer.break_circuit;
    let reduce = [];
    var request = {
      user_id: this.user?.id,
      filiale_id: this.user.filiale_id,
      datas: [itemAEnregistrer],
    };

    this.busySave = this.restClient
      .post("notification/validateOrInvalidate", request)
      .subscribe(
        (res) => {
          console.info("resul", res);
          this.loading = false;

          if (!res["hasError"]) {
            this.utilities.showNotification(
              "snackbar-success",
              this.utilities.formatMsgServeur(res["status"]["message"]),
              "bottom",
              "center",
            );
            this.getNotifications();
            this.modalRef.hide();
          } else {
            if (res["status"] && res["status"]["message"]) {
              this.utilities.showNotification(
                "snackbar-danger",
                this.utilities.formatMsgServeur(res["status"]["message"]),
                "bottom",
                "center",
              );
            }
          }
        },
        (err) => {
          this.utilities.showNotification(
            "snackbar-danger",
            this.utilities.getMessageEndPointNotAvailble(),
            "bottom",
            "center",
          );
          this.loading = false;
        },
      );
  }
  makItemAsRead(item) {
    console.info("item to save", item);

    this.loading = true;

    let itemAEnregistrer = Object.assign({}, item);
    var request = {
      user_id: this.user?.id,
      filiale_id: this.user.filiale_id,
      datas: [itemAEnregistrer],
    };

    this.busySave = this.restClient
      .post("notificationMarkedRead/create", request)
      .subscribe(
        (res) => {
          console.info("resul", res);
          this.loading = false;

          if (!res["hasError"]) {
            this.utilities.showNotification(
              "snackbar-success",
              this.utilities.formatMsgServeur(res["status"]["message"]),
              "bottom",
              "center",
            );
            this.getNotifications();
            this.modalRef.hide();
          } else {
            if (res["status"] && res["status"]["message"]) {
              this.utilities.showNotification(
                "snackbar-danger",
                this.utilities.formatMsgServeur(res["status"]["message"]),
                "bottom",
                "center",
              );
            }
          }
        },
        (err) => {
          this.utilities.showNotification(
            "snackbar-danger",
            this.utilities.getMessageEndPointNotAvailble(),
            "bottom",
            "center",
          );
          this.loading = false;
        },
      );
  }

  generateUniqueString() {
    // Get current timestamp in milliseconds
    var timestamp = new Date().getTime();

    // Generate a random number
    var randomNumber = Math.floor(Math.random() * 1000000); // Adjust range as needed

    // Concatenate timestamp and random number
    var uniqueString = timestamp.toString() + randomNumber.toString();

    return uniqueString;
  }

  getItemsSystemeGlobal(codification?) {
    // if(!this.itemToSave.police_id && !police_id){
    //   return
    // }
    if (!this.user || !this.user.id) {
      return;
    }
    let request = {
      user_id: this.user.id,
      // filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {
        // codification:codification
      },
    };

    this.busyGet = this.restClient
      .post("systemeGlobal/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            // this.itemsAvenant = _.orderBy(res["items"], ["libelle"], ["asc"]);
            localStorage.setItem("globalSystem", JSON.stringify(res["items"]));
          } else {
            // this.itemsAvenant = [];
            localStorage.removeItem("globalSystem");
          }
        },
        (err) => {
          // this.itemsAgence = [];
          localStorage.removeItem("globalSystem");
        },
      );
  }

  getDuree(createdAt?) {
    moment.locale("fr");

    let duration = moment().diff(moment(createdAt), "minutes");
    let message: any =
      "Il y a " + duration + " minute" + (duration > 1 ? "s" : "");

    if (duration > 60 * 24) {
      // superieur a un jour
      // Je convertir en jour
      duration = moment().diff(moment(createdAt), "days");
      message = "Il y a " + duration + " jour" + (duration > 1 ? "s" : "");
    } else {
      //Si c'est superieur à 60 minutes, on converti en hh
      if (duration > 60) {
        duration = moment().diff(moment(createdAt), "hour");
        message = "Il y a " + duration + " heure" + (duration > 1 ? "s" : "");
      }
    }

    return message;
  }

  /** On implemente un timer qui va tourner par intervalle de temps */
  refreshDataNotification() {
    this.getNotifications();
    this.requestRefreshNotifications = interval(
      10 * 60 * 1000,
    ) /* On actualise chaque 2 minutes */
      .subscribe((i) => {
        // this.getNotifications()
      });
  }

  /** Marquer le isOuvert pour les notifications qui n'on pas besoin de traitement */
  updateIsOuverNotification() {
    /** Recuperer ceux qui n'ont pas besoin de traitement */
    let listeNotificationSansTraitement = _.filter(
      this.listeNotifications,
      (o) => {
        return !o.hasValidation;
      },
    );

    console.info(
      " listeNotificationSansTraitement ",
      listeNotificationSansTraitement,
    );

    if (
      listeNotificationSansTraitement &&
      listeNotificationSansTraitement?.length > 0
    ) {
      listeNotificationSansTraitement.forEach((notif) => {
        notif.isOuvert = true;
      });
      var request = {
        user: this.user.id,
        datas: listeNotificationSansTraitement,
      };

      this.restClient.post("notification/update", request).subscribe(
        (res) => {
          if (!res["hasError"]) {
            if (res["items"] && res["items"].length > 0) {
              this.getNotifications();
              // this.utilities.showNotification("snackbar-success",this.utilities.formatMsgServeur(res["status"]["message"]),"bottom", "center");
            }
          } else {
            if (res["status"] && res["status"]["message"]) {
              // this.utilities.showNotification("snackbar-danger",this.utilities.formatMsgServeur(res["status"]["message"]),"bottom","center");
            }
          }
        },
        (err) => {
          // this.utilities.showNotification(
          //   "snackbar-danger",
          //   this.utilities.getMessageEndPointNotAvailble(),
          //   "bottom",
          //   "center"
          // );
        },
      );
    }
  }

  openToogle(isOpen) {
    console.info(" isOpen ", isOpen);

    // if(!isOpen) {
    //   // En ce moment le modal vient de se fermer je marque estOuvert true
    //   setTimeout(() => {
    //     this.updateIsOuverNotification();
    //   }, 2000);
    // }
  }
  onSubmitDecision(event) {
    console.log("event: ", event);
    this.confirmSaveItem(event);
  }

  ngAfterViewInit() {
    // set theme on startup
    if (localStorage.getItem("theme")) {
      this.renderer.removeClass(this.document.body, this.config.layout.variant);
      this.renderer.addClass(this.document.body, localStorage.getItem("theme"));
    } else {
      this.renderer.addClass(this.document.body, this.config.layout.variant);
    }

    if (localStorage.getItem("menuOption")) {
      this.renderer.addClass(
        this.document.body,
        localStorage.getItem("menuOption"),
      );
    } else {
      this.renderer.addClass(
        this.document.body,
        "menu_" + this.config.layout.sidebar.backgroundColor,
      );
    }

    if (localStorage.getItem("choose_logoheader")) {
      this.renderer.addClass(
        this.document.body,
        localStorage.getItem("choose_logoheader"),
      );
    } else {
      this.renderer.addClass(
        this.document.body,
        "logo-" + this.config.layout.logo_bg_color,
      );
    }

    if (localStorage.getItem("sidebar_status")) {
      if (localStorage.getItem("sidebar_status") === "close") {
        this.renderer.addClass(this.document.body, "side-closed");
        this.renderer.addClass(this.document.body, "submenu-closed");
      } else {
        this.renderer.removeClass(this.document.body, "side-closed");
        this.renderer.removeClass(this.document.body, "submenu-closed");
      }
    } else {
      if (this.config.layout.sidebar.collapsed === true) {
        this.renderer.addClass(this.document.body, "side-closed");
        this.renderer.addClass(this.document.body, "submenu-closed");
      }
    }
  }
  callFullscreen() {
    if (
      !document.fullscreenElement &&
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement &&
      !document.msFullscreenElement
    ) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.msRequestFullscreen) {
        document.documentElement.msRequestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    }
  }
  setLanguage(text: string, lang: string, flag: string) {
    this.countryName = text;
    this.flagvalue = flag;
    this.langStoreValue = lang;
    this.languageService.setLanguage(lang);
  }
  mobileMenuSidebarOpen(event: any, className: string) {
    const hasClass = event.target.classList.contains(className);
    if (hasClass) {
      this.renderer.removeClass(this.document.body, className);
    } else {
      this.renderer.addClass(this.document.body, className);
    }
  }
  callSidemenuCollapse() {
    const hasClass = this.document.body.classList.contains("side-closed");
    if (hasClass) {
      this.renderer.removeClass(this.document.body, "side-closed");
      this.renderer.removeClass(this.document.body, "submenu-closed");
    } else {
      this.renderer.addClass(this.document.body, "side-closed");
      this.renderer.addClass(this.document.body, "submenu-closed");
    }
  }
  logout() {
    // this.subs.sink = this.authService.logout().subscribe((res) => {
    //   if (!res.success) {
    //     this.router.navigate(["/authentication/signin"]);
    //   }
    // });
    this.authService.logout();
  }

  updatePassword() {
    let modal: any;
    modal = ModalUpdatePasswordComponent;
    this.modalRef = this.modalService.show(modal, {
      id: 1,
      class: "modal-custom",
      // data:boulangerie
    });
    // if (data) this.modalRef.content.currentData = data;
    this.modalRef.onHide.subscribe((res) => {
      console.info("hidden");
      // this.getData();
    });
  }

  getItemsExercice() {
    if (!this.user || !this.user.id) {
      return;
    }
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      // search_key: this.searchKey,
      data: {},
      index: 0,
      size: 1000,
    };

    this.busyGet = this.restClient
      .post("exercice/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"] && !res["hasError"]) {
            this.itemsExercice = res["items"];
            // this.selectedExercice = this.itemsExercice[0]
            this.selectedExercice = this.findObjectWithCurrentDate(
              this.itemsExercice,
            );
          } else {
            this.utilities.showNotification(
              "snackbar-danger",
              this.utilities.formatMsgServeur(res["status"]["message"]),
              "bottom",
              "center",
            );
            this.itemsExercice = [];
          }
        },
        (err) => {},
      );
  }

  capitalize(str) {
    return str.replace(/^\w/, (c) => c.toUpperCase());
  }

  onStopChannel() {
    this.websocketService.stopPeriodicUpdates();
  }

  findObjectWithCurrentDate(items) {
    const currentDate = new Date(); // Get the current date
    const currentDateString = currentDate.toISOString().split("T")[0]; // Format as YYYY-MM-DD

    return items.find((obj) => {
      const debutDate = new Date(obj.debut);
      const finDate = new Date(obj.fin);
      return debutDate <= currentDate && currentDate <= finDate;
    });
  }
}
